import ScanbotSDK from "scanbot-web-sdk";

// Initializes the Scanbot Web SDK against the self-hosted, same-origin engine
// (copied into /scanbot-engine/ at build time and pre-warmed by
// scanbotEnginePreload). If that init fails — e.g. the self-hosted engine
// assets were not deployed and 404 — it falls back to the SDK's default engine
// (the jsDelivr CDN) so document scanning still works instead of breaking.
//
// Pass the usual options (e.g. { licenseKey: "" }); `engine` is added here.
export async function initScanbotSdk(options = {}) {
  try {
    return await ScanbotSDK.initialize({ ...options, engine: "/scanbot-engine/" });
  } catch (selfHostError) {
    // eslint-disable-next-line no-console
    console.warn(
      "[scanbot] self-hosted engine init failed; falling back to CDN engine",
      selfHostError
    );
    return ScanbotSDK.initialize({ ...options });
  }
}
